import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/teamspeak': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M244.2 346.8c-2.4 12.5-10.6 20-22.5 24.3-9.2 3.2-50.1 1.6-61.7 1-18-1.3-33.2-8.5-43.4-24-14.5-22.5-19.5-47.7-14.5-73.9 4.6-24.5 24.6-34.7 46.3-22.7 15.2 7.5 42.5 27.4 63.4 46.6 20.4 18.7 34.8 36.4 32.4 48.7zM449.2 367.6c6.7 5.4 11.2 22 11.6 32.1 1 50.4-23.9 68-46.6 85.4-65.1 50-295.1 16.9-145.4 6.4 127.4-9 164.1-96.1 172.1-121.5 0.6-2 2.9-3.6 5-3.6 1 0 2.5 0.5 3.3 1.2zM511.2 245.2c0 17.2 1.9 34.6-1 51.7-4 24.7-29.1 41.7-53.2 36.7-7.2-1.7-9.4-7.2-9.4-14.2 0-28.1 0.8-56.4 0-84.6-1.9-75.8-36.2-132.8-102.3-169.4-111-60.4-253.2 7-277.8 131.5-6.1 30.4-1.7 48.3-3.7 125.8-0.3 7.2-4.3 11.2-12 11.5-30.8 1.4-51.8-18.2-51.8-49v-20.9l0.8-26.5c2.4-15.5 10.7-27 24.9-34 3.5-1.8 5.7-3.5 6.4-7.8 6.1-33.4 19.5-64 39.3-91.7 2.3-3.1 4-5.3 1-9.3-3.7-5.4-1-10.2 3-14.5 28.1-31.8 61.9-55.1 102-67.4 96-29.5 180.1-9.3 252.3 60.5 6.7 6.4 15.5 12.9 7 24.4-1.3 1.8 1.1 3.5 2.2 5 17.2 23.2 35.3 65.1 40.4 93.6 0.9 3.7 3 5.1 5.9 6.4 17.4 8.8 25.7 23.3 26 42.2zM351.6 376.7l-51.6-7.7c-22.8-5.9-51-32.7 22.2-60.8 21.6-8.5 85.7-37.2 87.8 8 0.9 32-21.9 63.3-58.4 60.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/teamspeak.js
// module id = 1046
// module chunks = 0